module.exports = __webpack_public_path__ + "static/media/go.feeb8fbd.png";